import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export default function DashboardHero() {
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start start", "end start"]
    });

    // Parallax & 3D Tilt transforms based on scroll
    const rotateX = useTransform(scrollYProgress, [0, 1], [20, 0]);
    const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1]);
    const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0.5]);
    const y = useTransform(scrollYProgress, [0, 1], [0, 100]);

    return (
        <div ref={containerRef} style={{
            perspective: '1200px',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative'
        }}>
            <motion.div style={{
                rotateX,
                scale,
                y,
                opacity,
                transformStyle: 'preserve-3d',
                width: '90%',
                maxWidth: '1200px',
                aspectRatio: '16/9',
                background: '#0a0a0c',
                borderRadius: '24px',
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 50px 100px -20px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1) inset',
                overflow: 'hidden',
                position: 'relative'
            }}>
                {/* Glare Effect */}
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, height: '100%',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 40%)',
                    pointerEvents: 'none',
                    zIndex: 10
                }} />

                {/* Simulated Dashboard Content (Abstracted) */}
                <div style={{ padding: '24px', display: 'flex', gap: '24px', height: '100%', flexWrap: 'wrap' }}>
                    {/* Sidebar - Hidden on tiny screens */}
                    <div className="hidden sm:block" style={{ background: 'rgba(255,255,255,0.03)', borderRadius: '16px', height: '100%', width: '180px', flexShrink: 0 }} />

                    {/* Main Content */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', flex: 1, minWidth: '200px' }}>
                        {/* Header Area */}
                        <div style={{ height: '60px', background: 'rgba(255,255,255,0.03)', borderRadius: '16px' }} />

                        {/* Metrics Area */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))', gap: '16px' }}>
                            <div style={{ height: '80px', background: 'var(--accent)', borderRadius: '12px', opacity: 0.1 }} />
                            <div style={{ height: '80px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }} />
                            <div style={{ height: '80px', background: 'rgba(255,255,255,0.03)', borderRadius: '12px' }} />
                        </div>

                        {/* Chart Area */}
                        <div style={{ flex: 1, background: 'linear-gradient(to bottom, rgba(255,255,255,0.05), transparent)', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.05)', minHeight: '100px' }} />
                    </div>
                </div>

                {/* Reflection/Bottom Gloss */}
                <div style={{
                    position: 'absolute',
                    bottom: 0, left: 0, right: 0, height: '30%',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                    pointerEvents: 'none'
                }} />
            </motion.div>
        </div>
    );
}
